import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 32px;
  background-color: ${({ theme }) => theme.colors.background || '#fff'};
`

export const IconContainer = styled.div`
  margin-bottom: 32px;
`

export const Title = styled.span`
  ${({ theme }) => css`
    font-size: 28px;
    font-weight: bold;
    color: ${theme.colors.text};
    margin-bottom: 12px;
    text-align: center;
  `}
`

export const Message = styled.span`
  ${({ theme }) => css`
    font-size: 16px;
    color: ${theme.colors.text};
    text-align: center;
    margin-bottom: 32px;
  `}
`
